var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root-box"},[_c('el-tabs',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('el-tab-pane',{attrs:{"label":"质检报告","name":"ref1"}},[_c('QcReport')],1),_c('el-tab-pane',{attrs:{"label":"每日质检详情","name":"ref2"}},[_c('DriverDailyReport')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }